import {api} from '../middleware/api';

// Define endpoints using injectApi pattern
export const companyApi = api
  .enhanceEndpoints({addTagTypes: ['Company']})
  .injectEndpoints({
    endpoints: builder => ({
      getCompanys: builder.query<acompany[], void>({
        query: () => `company/`,
        providesTags: ['Company'],
      }),
      getKey: builder.query<any, void>({
        query: () => `company/getkey`,
      }),
      getCompanysByUser: builder.query<any[], void>({
        query: () => `company/byuser`,
      }),
      getCompanyById: builder.query<acompany, string>({
        query: id => `company/byid/${id}`,
        providesTags: ['Company'],
      }),
      getCompanyByCode: builder.query<acompany, string>({
        query: code => `company/code/${code}`,
        providesTags: ['Company'],
      }),
      getCurrBill: builder.query<any, string>({
        query: cid => `company/currbill/${cid}`,
        providesTags: ['Company'],
      }),
      getCurrBillDetails: builder.query<any, string>({
        query: cid => `company/currbilldetails/${cid}`,
        providesTags: ['Company'],
      }),
      insertLogo: builder.mutation<{}, FormData>({
        query: (data: FormData) => ({
          url: `company/insertlogo`,
          method: 'POST',
          body: data,
        }),
      }),
      uploadImage: builder.mutation<
        { key: string; fileName: string },
        FormData
      >({
        query: (data: FormData) => ({
          url: `company/uploadimage`,
          method: 'POST',
          body: data,
        }),
      }),
      insertCompany: builder.mutation({
        query: company => ({
          url: `company/`,
          method: 'POST',
          body: company,
        }),
        invalidatesTags: ['Company'],
      }),
      updateCompany: builder.mutation({
        query: company => ({
          url: `company/`,
          method: 'PUT',
          body: company,
        }),
        invalidatesTags: ['Company'],
      }),
      deleteCompany: builder.mutation({
        query: company => ({
          url: `company/${company.cm_id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Company'],
      }),
    }),
    overrideExisting: false,
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetCompanysQuery,
  useLazyGetKeyQuery,
  useGetCompanysByUserQuery,
  useGetCompanyByIdQuery,
  useGetCompanyByCodeQuery,
  useGetCurrBillQuery,
  useGetCurrBillDetailsQuery,
  useInsertLogoMutation,
  useUploadImageMutation,
  useInsertCompanyMutation,
  useUpdateCompanyMutation,
  useDeleteCompanyMutation,
} = companyApi;
